import LocalStorage from "local-storage-json"
import Keyset from "@frog/source/utility/Keyset.js"

const music = {
    // "hero": new Audio(require("music/hero.wav")),
    // "victory": new Audio(require("music/victory.wav")),
    // "failure": new Audio(require("music/failure.wav")),
    // "evil": new Audio(require("music/evil.wav")),
    // "overworld": new Audio(require("music/overworld.wav")),
    // "hero-alt": new Audio(require("music/hero-alt.wav")),
}

const sounds = {}
// const context = require.context("sounds", true)
// context.keys().forEach(function(key) {
//     sounds[key.substring(2, key.length - 4)] = new Audio(context(key))
// })

// https://frog-tactics.s3-us-west-2.amazonaws.com/assets/music/overworld.wav

const settings = {
    "volume": 0.5
}

// move this to a parser?
let triggers = {}
// import prototriggers from "@frog/source/data/audio.csv"
// const headers = prototriggers.shift()
// prototriggers.forEach((prototrigger) => {
//     headers.forEach((header, index) => {
//         prototrigger[header] = prototrigger[index]
//     })
//
//     const trigger = {
//         "name": prototrigger["Name"],
//         "description": prototrigger["Description"],
//         "volume": parseFloat(prototrigger["Volume"]),
//         "type": prototrigger["Type"],
//         "files": [
//             prototrigger["File 1"],
//             prototrigger["File 2"],
//             prototrigger["File 3"],
//             prototrigger["File 4"],
//             prototrigger["File 5"],
//         ].filter((file) => !!file)
//     }
//
//     trigger.audio = trigger.files.map((file) => {
//         return new Audio("https://frog-tactics.s3-us-west-2.amazonaws.com/" + file)
//     })
//
//     triggers[trigger.name] = trigger
// })


triggers = Keyset.merge(triggers, {
    "Music:Normal": {
        "type": "march",
        // "volume": 0,
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Main Theme Full.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Main Theme Loop.wav").default),
        ]
    },
    "Music:Final": {
        "type": "march",
        // "volume": 0,
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Final Level Theme FULL.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Final Level Theme LOOP.wav").default),
        ],
        "killTrigger": "Music:Normal",
    },
    "Selection:Start": {"volume": 0.33, "audio": new Audio(require("@frog/source/audio/ld47/Select.wav").default)},
    "Selection:Cancel": {"volume": 0.33, "audio": new Audio(require("@frog/source/audio/ld47/UnSelect.wav").default)},
    "Selection:Finish": {"volume": 0.85, "audio": new Audio(require("@frog/source/audio/ld47/PerformAction.wav").default)},
    "Selection:Move": {"volume": 0.33, "audio": new Audio(require("@frog/source/audio/ld47/Hover.wav").default)},
    // "Unit:Move": {
    //     "type": "random",
    //     "audio": [
    //         new Audio(require("@frog/source/audio/ld47/UnitMoveSand1.wav").default),
    //         new Audio(require("@frog/source/audio/ld47/UnitMoveSand2.wav").default),
    //         new Audio(require("@frog/source/audio/ld47/UnitMoveSand3.wav").default),
    //     ]
    // },
    "EndTurn": {
        "volume": 0.85,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 SFX CONFIRM (Generic).wav").default)
    },
    "UndoAction": {
        "volume": 0.85,
        // "audio": new Audio(require("@frog/source/audio/ld47/LD47 SFX TEXT WINDOW CLOSE 2.wav").default)
        "audio": new Audio(require("@frog/source/audio/ld47/UndoAction.wav").default)
    },
    "Unit:Death": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 SFX CANNOT CONFIRM.wav").default)
    },
    "Unit:Death:Falling": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 Falling Off Map.wav").default)
    },
    "Unit:Escape": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 Escape Map Zipline.wav").default)
    },
    "Flipper:Swing": {
        "volume": 1,
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Bo Staff Flip.wav").default)
        ]
    },
    "Pusher:Swing": {
        "volume": 1,
        "type": "sequence",
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Push 1.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Push 2.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Push 3.wav").default),
        ]
    },
    "Robot:Swing": {
        "volume": 1,
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Robot Sounds.wav").default)
        ]
    },
    "Puller:Throw": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 Frisbee Throw.wav").default)
    },
    "Puller:Pull": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 Frisbee Pull In.wav").default)
    },
    "Aoe-er:Shoot": {
        "volume": 1,
        "audio": new Audio(require("@frog/source/audio/ld47/LD47 Cannon Fire.wav").default)
    },
    "Aoe-er:Explosion": {
        "volume": 1,
        "type": "sequence",
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Cannon Explosion.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Cannon Explosion.wav").default),
        ]
    },
    "Victory": {
        "volume": 1,
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Victory Theme 1.wav").default)
        ],
    },
    "Victory:Final": {
        "volume": 1,
        "type": "march",
        "audio": [
            new Audio(require("@frog/source/audio/ld47/LD47 Victory Theme ENDGAME.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Main Theme Full.wav").default),
            new Audio(require("@frog/source/audio/ld47/LD47 Main Theme Loop.wav").default),
        ],
        "killTrigger": "Music:Final",
    }
})

const AUDIOMIX = new class Audiomix {
    constructor() {
        this.userSoundVolume = LocalStorage.get("sound-volume")
        this.userMusicVolume = LocalStorage.get("music-volume")

        if(this.userSoundVolume == undefined) {
            this.userSoundVolume = 0.5
        }
        if(this.userMusicVolume == undefined) {
            this.userMusicVolume = 0.5
        }
        // this.musicPlaying = LocalStorage.get("musicPlaying")
        // if(this.musicPlaying == undefined) {
        //     this.musicPlaying = {"track": "debris", "time": Date.now()}
        //     LocalStorage.set("musicPlaying", this.musicPlaying)
        // }
    }
    playMusic(name, params) {
        params = params || {}
        if(this.music === music[name]) {
            // console.log("Could not find the music.")
            return
        }
        if(this.music !== undefined) {
            this.music.pause()
        }
        this.music = music[name]
        this.music.volume = this.musicVolume
        this.music.currentTime = params.currentTime || 0
        this.music.loop = params.loop || false
        this.music.play()
        // this.music.volume = this.musicVolume * this.devMusicVolume
        // if(__STAGE__ === "DEVELOPMENT") {
        //     this.music.currentTime = (Date.now() - this.musicPlaying.time) / 1000
        // }
        // this.music.addEventListener("ended", () => {
        //     LocalStorage.set("musicPlaying", {
        //         "time": Date.now(),
        //         "track": "debris"
        //     })
        //     this.music.currentTime = 0
        //     this.music.play()
        // })
    }
    stopMusic() {
        if(this.music !== undefined) {
            this.music.pause()
        }
    }
    trigger(key) {
        const trigger = triggers[key]
        if(trigger == undefined) {
            console.log("Could not find audio trigger:", key)
            return
        }

        if(trigger.killTrigger != undefined
        && triggers[trigger.killTrigger] != undefined) {
            if(triggers[trigger.killTrigger].audio instanceof Audio) {
                triggers[trigger.killTrigger].audio.pause()
            } else if(triggers[trigger.killTrigger].audio instanceof Array) {
                triggers[trigger.killTrigger].audio.forEach((audio) => audio.pause())
            }
        }

        if(trigger.audio instanceof Audio) {
            // trigger.audio.pause()
            playSound(trigger.audio, trigger.volume)
        } else if(trigger.audio instanceof Array) {
            // trigger.audio.forEach((sound) => sound.pause())
            if(trigger.type == "synchronous") {
                trigger.audio.forEach((sound) => playSound(sound, trigger.volume))
            } else if(trigger.type == "sequence") {
                playSound(trigger.audio[0], trigger.volume)
                trigger.audio.push(trigger.audio.shift())
            } else if(trigger.type == "random") {
                playSound(trigger.audio[Math.floor(Math.random() * trigger.audio.length)], trigger.volume)
            } else if(trigger.type == "march") {
                marchAudio(trigger.audio.map((audio) => audio), trigger.volume)
            } else {
                playSound(trigger.audio[0], trigger.volume)
            }
        }
    }
    playSound(name, volume) {
        // if(sounds[name] == undefined) {
        //     // console.log("Could not find the sound.")
        //     return
        // }
        // if(sounds[name] == undefined) {
        //     sounds[name] = new Audio(name)
        // }
        sounds[name].currentTime = 0
        sounds[name].volume = /*this.userSoundVolume * */(volume || 0.5)
        sounds[name].play()
    }
    stopSound(name) {
        sounds[name].pause()
    }
    setMusicVolume(volume) {
        this.userMusicVolume = volume
        if(this.music !== undefined) {
            this.music.volume = this.musicVolume
        }
        LocalStorage.set("music-volume", volume)
    }
    setSoundVolume(volume) {
        this.userSoundVolume = volume
        LocalStorage.set("sound-volume", volume)
    }
    get musicVolume() {
        return this.userMusicVolume
    }
    update(delta) {
        if(this.music !== undefined) {
            this.music.volume -= (this.music.volume - this.musicVolume) / 25
            if(Math.abs(this.music.volume - this.musicVolume) < 0.001) {
                this.music.volume = this.musicVolume
            }
        }
    }
}

function playSound(sound, volume = 1) {
    sound.pause()
    sound.volume = volume * settings.volume
    sound.currentTime = 0
    sound.play()
}

function marchAudio(audios, volume = 1) {
    const audio = audios.shift()
    audio.pause()
    audio.volume = volume * settings.volume
    audio.currentTime = 0
    if(audios.length == 0) {
        audio.loop = true
    } else {
        // TODO: what happens if this gets added multiple times
        audio.addEventListener("ended", () => {
            marchAudio(audios, volume)
        })
    }
    audio.play()
}

// let hasTriggered = false
// document.addEventListener("click", () => {
//     if(hasTriggered == false) {
//         hasTriggered = true
//         AUDIOMIX.trigger("Music:Normal")
//     }
// })


export default AUDIOMIX
window.frog = window.frog || {}
window.frog.audiomix = AUDIOMIX
